<template>
	<div class="meta-info">
		<span v-if="!block" class="meta-info">
			<span>{{metaCount | toK}}</span> 
			<router-link v-if="to" :to="to" :replace="replace" tag="span" class="font-weight-light">
				{{metaName}}
			</router-link>
			<span v-else class="font-weight-light">
				{{metaName}}
			</span>
		</span>
		<span v-else>
			<span class="meta-info d-block">{{metaCount | toK}}</span>
			<router-link v-if="to" :to="to" :replace="replace" tag="span" class="grey--text caption">
				{{metaName}}
			</router-link>
			<span v-else class="grey--text caption">
				{{metaName}}
			</span>
		</span>
	</div>
</template>
<script>
	export default {
		props: {
			block: Boolean,
			metaName: String,
			metaCount: Number,
			replace: Boolean,
			to: String
		}
	}
</script>